<h2 mat-dialog-title>Legal Information</h2>

<mat-dialog-content>
  <p><strong>User:</strong> {{ data.userEmail || 'Unknown' }}</p>
  <p><strong>Mobile:</strong> {{ phoneLabel }}</p>
  <p><strong>Industry:</strong> {{ industryLabel }}</p>

  <div class="document-section" *ngIf="ffcSignedUrl && ffcSafeSignedUrl">
    <h3>FFC Document</h3>
    <div *ngIf="isFfcImagePreview; else ffcIframePreview" class="preview-canvas">
      <img class="preview-image" [src]="ffcSignedUrl" alt="FFC document preview" />
    </div>
    <ng-template #ffcIframePreview>
      <iframe
        [src]="ffcSafeSignedUrl"
        title="FFC document preview"
        class="preview-frame"
      ></iframe>
    </ng-template>
  </div>

  <div class="document-section" *ngIf="idSignedUrl && idSafeSignedUrl; else missingIdDocument">
    <h3>ID Document</h3>
    <div *ngIf="isIdImagePreview; else idIframePreview" class="preview-canvas">
      <img class="preview-image" [src]="idSignedUrl" alt="ID document preview" />
    </div>
    <ng-template #idIframePreview>
      <iframe
        [src]="idSafeSignedUrl"
        title="ID document preview"
        class="preview-frame"
      ></iframe>
    </ng-template>
  </div>

  <ng-template #missingIdDocument>
    <p>No ID document preview URL is available for this user.</p>
  </ng-template>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Close</button>
</mat-dialog-actions>

<style>
  .document-section {
    margin-top: 16px;
  }

  .document-section h3 {
    margin: 0 0 12px;
  }

  .preview-canvas {
    width: 100%;
    min-height: 65vh;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 6px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 16px;
    overflow: auto;
    box-sizing: border-box;
  }

  .preview-image {
    display: block;
    max-width: 100%;
    height: auto;
  }

  .preview-frame {
    width: 100%;
    min-height: 65vh;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 6px;
  }
</style>
